/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";
//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;

const listTiming = async (id: any) => {
  return await axios
    .get(`${API_URL}get-timing/${id}`, getToken())
    .then((response) => {
            return response.data;
    });
};

const updateTiming = async (data: any) => {
    return await axios
    .post(`${API_URL}update-timing`, data, getToken())
    .then((response) => {
            return response.data;
    });
};

const ProfileDetails = async (chefId: any) => {
  const response = await axios.get(`${API_URL}view-chef/${chefId}`, getToken());
  return response.data;
};
const DeleteChefAccount = async (id: any) => {
  const response = await axios.post(`${API_URL}delete-chef/${id}`);
  return response.data;
};
const UpdateProfile = async (data: any, chefId: any) => {
  const response = await axios.put(
    `${API_URL}update-chef/${chefId}`,
    data, getToken()
  );
  return response.data;
};
const BannerPictureUpdate = async (data: FormData, chefId: any) => {
  const response = await axios.put(
    `${API_URL}update-banner/${chefId}`,
    data, getToken()
  );
  return response.data;
};

const BannerPictureDelete = async (chefId: any, payload: { deleteIndex?: number; filename?: string }) => {
  const response = await axios.delete(
    `${API_URL}delete-banner/${chefId}`,
    {
      ...getToken(), // includes headers (like Authorization)
      data: payload  // axios supports sending body in DELETE requests
    }
  );
  return response.data;
};


const UpdatePassword = async (data: any, chefId: any) => {
  const response = await axios.post(
    `${API_URL}change-password/${chefId}`,
    data,
  );
  return response.data;
};
const BannerDetails = async (id: any) => {
  const response = await axios.get(`${API_URL}get-banner/${id}`, getToken());
  return response.data;
};
// _requests.tsx
const DeleteBanner = async (chefId: string, filename: string) => {
  return axios.delete(`${API_URL}delete-banner/${chefId}`, {
    ...getToken(),
    data: { filename }, // send filename in body
  });
};

 

const forgotPassword = async (data: any) => {
    const response = await axios.post(
    `${API_URL}forgot-password`,
    data, getToken()
  );
  return response.data;
};
const decryptData = async (userData: any) => {
  const response = await axios.post(`${API_URL}decrypt-data`, {
    data: userData
  }, getToken());
  return response.data;
};
const addressUserFetch = async (data: any) => {
  const response = await axios.post(`${API_URL}fetch-address`, data, getToken());
    return response.data.data;
};

const callGooglePlacesApi = async (address: any) => {
  const response = await axios.get(
    `${API_URL}fetch-location?input=${address}`, getToken()
  );
  return response.data;
};

const locationLatLongAPIFetch = async (place_id: any) => {
  const response = await axios.get(
    `${API_URL}fetch-location-latLong?input=${place_id}`, getToken()
  );
  return response.data;
};

const getSounds = async () => {
  const res = await axios.get(`${API_URL}get-sound-list`, getToken());
  return res;
};


const listCertificate = async (chef_id: any) => {
        return await axios
    .post(`${API_URL}list-certificate`,{chef_id}, getToken())
    .then((response) => {
            return response.data;
    });
};

const addCertificate = async (data: FormData) => {
    return await axios
    .post(`${API_URL}add-certificate`, data, getToken())
    .then((response) => {
            return response.data;
    });
};
const updateCertificate = async (id:any,data: FormData) => {
    return await axios
    .put(`${API_URL}update-certificate/${id}`, data, getToken())
    .then((response) => {
            return response.data;
    });
};
const viewCertificate = async (id: any) => {
  const response = await axios.get(`${API_URL}view-certificate/${id}`);
  return response.data;
};
const deleteCertificate = async (id: any) => {
  const response = await axios.put(`${API_URL}delete-certificate/${id}`);
  return response.data;
};
const bulkDeleteDishes = async (data: { dishIds: string[] }) => {
  
  const response = await axios.post(`${API_URL}bulk-delete`, data);
  return response.data;
};

const bulkEnableDisableDishes = async (data: { ids: string[]; enableDisableStatus: boolean }) => {
  const response = await axios.post(`${API_URL}bulk-enable-disable`, data);
  return response.data;
};


export {
  listTiming,
  updateTiming,
  UpdateProfile,
  ProfileDetails,
  BannerDetails,DeleteChefAccount,
  BannerPictureUpdate,
  decryptData,
  forgotPassword,
  UpdatePassword,
  addressUserFetch,
  locationLatLongAPIFetch,
  callGooglePlacesApi,getSounds,
  listCertificate,
  addCertificate,
  updateCertificate,
  viewCertificate,
  deleteCertificate,
  bulkDeleteDishes,
  bulkEnableDisableDishes,
  BannerPictureDelete ,
  DeleteBanner
};